<template>
  <DigestsParams />
  <LoaderFullPage v-if="store.loading" />
  <DigestsListing />
  <FreemiumUpgradePopup
    title="Souscrire à l'abonnement Essentiel"
    ref="freemiumUpgradePopup"
    closable
  >
    <div class="text-centered">
      <h4 class="title-medium-semibold">Récapitulatifs</h4>
      <p>
        Créez vos propres récapitulatifs pour rester informé périodiquement sur
        les sujets qui vous intéressent.
      </p>
    </div>
  </FreemiumUpgradePopup>
</template>

<script setup lang="ts">
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import DigestsParams from "@follaw-fr/components/alerting/organisms/DigestsParams.vue";
import DigestsListing from "@follaw-fr/components/alerting/organisms/DigestsListing.vue";
import { useDigestsStore } from "@follaw-fr/stores/digests.js";
import { openDigestPaywallModalKey } from "@follaw-fr/constants/injection-keys";
import FreemiumUpgradePopup from "@follaw-fr/components/reusable/atoms/FreemiumUpgradePopup.vue";
import { provide, ref } from "vue";

const freemiumUpgradePopup = ref<typeof FreemiumUpgradePopup | null>(null);
const openFreemiumModal = () => {
  freemiumUpgradePopup.value?.open();
};
provide(openDigestPaywallModalKey, openFreemiumModal);

const store = useDigestsStore();
store.readDigests();
</script>
